import React, { useEffect } from "react";
import Highcharts from "highcharts";
import Highmaps from "highcharts/modules/map";
import "../WorldMapChart/WorldMapChart.css";

// Initialize the map module
// Highmaps(Highcharts);

const WorldMapChart = () => {
  useEffect(() => {
    const fetchData = async () => {
      // Fetch the map data
      const topology = await fetch(
        "https://code.highcharts.com/mapdata/custom/world.topo.json"
      ).then((response) => response.json());

      const data = [
        [
          "New York Stock Exchange",
          "USA",
          "2022",
          40.71,
          -74.01,
          2500,
          3000,
          2800,
          2700,
        ], // Stock data for NYSE
        [
          "London Stock Exchange",
          "UK",
          "2022",
          51.51,
          -0.12,
          2400,
          2900,
          2700,
          2600,
        ], // Stock data for LSE
        [
          "Tokyo Stock Exchange",
          "Japan",
          "2022",
          35.68,
          139.76,
          2200,
          2700,
          2500,
          2400,
        ], // Stock data for TSE
        [
          "Shanghai Stock Exchange",
          "China",
          "2022",
          31.23,
          121.47,
          2100,
          2500,
          2300,
          2200,
        ], // Stock data for SSE
        [
          "Euronext Paris",
          "France",
          "2022",
          48.85,
          2.35,
          2100,
          2600,
          2400,
          2300,
        ], // Stock data for Euronext Paris
        [
          "Frankfurt Stock Exchange",
          "Germany",
          "2022",
          50.11,
          8.68,
          2300,
          2800,
          2600,
          2500,
        ], // Stock data for Frankfurt
        ["BSE Sensex", "India", "2022", 19.08, 72.86, 2400, 2900, 2700, 2600], // Stock data for BSE Sensex
        ["NASDAQ", "USA", "2022", 40.73, -73.94, 2600, 3100, 2900, 2800], // Stock data for NASDAQ
        [
          "Toronto Stock Exchange",
          "Canada",
          "2022",
          43.65,
          -79.38,
          2200,
          2700,
          2500,
          2400,
        ], // Stock data for TSX
        [
          "Australian Stock Exchange",
          "Australia",
          "2022",
          -33.86,
          151.21,
          2000,
          2500,
          2300,
          2200,
        ], // Stock data for ASX
        ["Bovespa", "Brazil", "2022", -23.55, -46.63, 2100, 2600, 2400, 2300], // Stock data for Bovespa
      ];

      // Highcharts map initialization
      Highcharts.mapChart("container", {
        chart: {
          map: topology,
          height: 300,
        },
        legend: {
          enabled: false,
        },
        mapNavigation: {
          enabled: true,
          buttonOptions: {
            verticalAlign: "bottom",
          },
        },
        mapView: {
          fitToGeometry: {
            type: "MultiPoint",
            coordinates: [
              [-164, 54], // Alaska west
              [-35, 84], // Greenland north
              [179, -38], // New Zealand east
              [-68, -55], // Chile south
            ],
          },
        },
        tooltip: {
          headerFormat: "",
          pointFormat:
            "{point.city} ({point.country}, {point.year})<br/>" +
            "Total medals: {point.z}<br/>" +
            '<span style="color: #ffd700;">\u25CF</span> ' +
            "{point.gold}<br/>" +
            '<span style="color: #c0c0c0;">\u25CF</span> ' +
            "{point.silver}<br/>" +
            '<span style="color: #cd7f32;">\u25CF</span> ' +
            "{point.bronze}<br/>",
          style: {
            color: "#999",
            fontSize: "14px",
          },
          backgroundColor: "white", // Ensures no shadow effect
          borderWidth: 1,
          borderColor: "#999",
          borderRadius: 0,
          padding: 10,
          shadow: false, // Removes box shadow
      },      
        series: [
          {
            name: "World map",
            nullColor: "#7a86df",
          },
          {
            name: "Stock Exchanges",
            type: "mapbubble",
            color: "#e6b26a",
            lineWidth: 1,
            keys: [
              "city",
              "country",
              "year",
              "lat",
              "lon",
              "z",
              "gold",
              "silver",
              "bronze",
            ],
            data: data,
            minSize: "5%",
            maxSize: "12.5%",
            dataLabels: {
              enabled: true,
              style: {
                color: "rgb(0 0 0)",       // Black text color
                fontSize: "12px",          // Small font size
                fontWeight: "normal",      // Normal font weight
                fill: "rgb(0 0 0)",        // Black fill color
                letterSpacing: "1px",      // Adds slight letter spacing
                textShadow: "none",        // Explicitly removes text shadow
              },
            },
            
            accessibility: {
              point: {
                valueDescriptionFormat:
                  "{point.city}, {point.country}, {point.year}. " +
                  "Total medals: {point.z}. Gold: {point.gold}, silver: {point.silver}, bronze: {point.bronze}.",
              },
            },
          },
        ],
      });
    };

    fetchData();
  }, []);
  return (
    <>
      <section className="section">
        <div className="world-container">
          <div className="world-header">
            <h1>Global Stock Market Overview <sub style={{color: "blue"}}>(Topology World chart)</sub></h1>
          </div>

          <div className="world-parent">
            <div className="world-count-wrapper">
              <div>
                <i
                  className="fa-solid fa-circle"
                  style={{ color: "#7a86df" }}
                ></i>{" "}
                Stock Exchange
              </div>
              <div>
                <i
                  className="fa-solid fa-circle"
                  style={{ color: "#e6b26a" }}
                ></i>{" "}
                Report Value
              </div>
            </div>

            <div className="world-chart-container">
              <div id="container"></div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WorldMapChart;
